import { updates } from '@/mocks/home';

const tagColors: Record<string, string> = {
  '新片上线': 'bg-accent-100 text-accent-700',
  '剧集完结': 'bg-primary-100 text-primary-700',
  '站内活动': 'bg-amber-100 text-amber-700',
  '功能更新': 'bg-emerald-100 text-emerald-700',
  '内容扩展': 'bg-sky-100 text-sky-700',
  '热门推荐': 'bg-rose-100 text-rose-700',
  '体验优化': 'bg-teal-100 text-teal-700',
  '频道更新': 'bg-violet-100 text-violet-700',
  '数据捷报': 'bg-orange-100 text-orange-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900">最新动态</h2>
          </div>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-0.5 bg-background-200/70"></div>

          <div className="space-y-5 md:space-y-6">
            {updates.map((item, idx) => (
              <div key={item.id} className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-14">
                <div className={`absolute left-[13px] md:left-[19px] top-1.5 w-2.5 h-2.5 md:w-3 md:h-3 rounded-full border-2 border-background-50 ${
                  idx === 0 ? 'bg-primary-500' : 'bg-background-300'
                }`}></div>

                <div className="flex-shrink-0">
                  <span className="text-xs md:text-sm font-bold text-foreground-400 bg-background-100 px-3 py-1 rounded-lg whitespace-nowrap">
                    {item.date}
                  </span>
                </div>

                <div className="flex-1 min-w-0 bg-background-100 rounded-xl p-4 md:p-5 hover:bg-background-100/80 transition-colors duration-200 cursor-pointer border border-background-200/50">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
                    <span className={`inline-flex self-start text-xs font-medium px-2.5 py-0.5 rounded-full whitespace-nowrap ${tagColors[item.tag] || 'bg-background-200 text-foreground-500'}`}>
                      {item.tag}
                    </span>
                    <h3 className="text-sm md:text-base font-medium text-foreground-800">
                      {item.title}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}